import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { SearchBanner } from '@massds/mayflower-react';

class SearchBar extends Component {
  constructor(props) {
    super(props);
    const { query } = this.props;
    this.state = {
      query
    };
  }

  handleClick = (e) => {
    e.preventDefault();
    const { query = '' } = this.state;
    const { updateQuery } = this.props;
    if (query.length > 0) {
      e.preventDefault();
      // Handles updating results when changing query terms since navigate doesn't reconstruct this component.
      updateQuery(query);
      navigate(`/search?query=${query}&page=1`);
    }
  };

  updateSearch = (e) => {
    this.setState({ query: e });
  };

  render() {
    const { query } = this.state;
    const bannerProps = {
      searchBox: {
        placeholder: '',
        buttonSearch: {
          onClick: this.handleClick,
          'aria-label': 'Search',
          text: 'Search'
        },
        onChange: this.updateSearch,
        defaultText: query
      },
      filterBox: null
    };
    return<SearchBanner {...bannerProps} />;
  }
}

SearchBar.propTypes = {
  // The query string past from the url query param
  query: PropTypes.string,
  // Function passed from search.js setting the query to state to query new search results
  updateQuery: PropTypes.func
};

export default SearchBar;
